import { render, staticRenderFns } from "./EmptyTopbar.vue?vue&type=template&id=0712f298&scoped=true&"
import script from "./EmptyTopbar.vue?vue&type=script&lang=ts&"
export * from "./EmptyTopbar.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyTopbar.vue?vue&type=style&index=0&id=0712f298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712f298",
  null
  
)

export default component.exports